import React from "react";
import "./TabsNavbar.css";
import { useTranslation } from "react-i18next";

function TabsNavbar({
  tabs,
  activeTab,
  setActiveTab,
  center,
  className = "",
  disabled,
  disabledIndex,
  disabledIndexes = [],
  tabClassName,
  withBottomBorder,
  bottom = "-16px",
  secondary,
  notifications,
}) {
  const { t } = useTranslation("common");
  const handleClick = (tabName) => {
    setActiveTab(tabName);
  };

  const checkActive = (tabName) => {
    return activeTab === tabName ? "active" : "";
  };

  const centerClassName = center ? "center" : "";
  const botBorderClassName = withBottomBorder ? "botBorder" : "";

  if (secondary)
    return (
      <div
        className={`tabsNavbar p-0 alignH bg-whiteGrey ${centerClassName} ${botBorderClassName} ${className} tab-disabled ${
          secondary ? "secondary" : ""
        }`}
      >
        {tabs.map((tab, index) => {
          const activeClassName = checkActive(tab);
          const notificationsCount = notifications?.[tab] ?? 0;
          return (
            <button
              className={`tabBtn flex-1 h100 border-0 d-flex justify-content-center px-3 bg-transparent f15 sBold text-lightBlack position-relative ${activeClassName} ${tabClassName}`}
              onClick={() => handleClick(tab)}
              key={index}
              disabled={(index > 0 && disabled) || disabledIndex === index}
            >
              {t(`${tab}`)}
              {notificationsCount > 0 && (
                <span
                  className="d-flex align-items-center justify-content-center align-middle f12 text-white sBold ms-2"
                  style={{
                    borderRadius: notificationsCount < 10 ? "50%" : "20px",
                    backgroundColor: "#a3c5ed",
                    width: notificationsCount < 10 ? "20px" : "35px",
                    minWidth: notificationsCount < 10 ? "20px" : "35px",
                    height: notificationsCount < 10 ? "20px" : "auto",
                    minHeight: notificationsCount < 10 ? "20px" : "auto",
                    lineHeight: "normal",
                  }}
                >
                  {notificationsCount}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );

  return (
    <div
      className={`tabsNavbar alignH bg-whiteGrey no-scrollbar overflow-auto ${centerClassName} ${botBorderClassName} ${className} tab-disabled ${
        secondary ? "secondary" : ""
      }`}
    >
      {tabs.map((tab, index) => {
        const activeClassName = checkActive(tab);
        const notificationsCount = notifications?.[tab] ?? 0;
        return (
          <button
            className={`tabBtn text-nowrap h100 border-0 d-flex justify-content-center px-3 mx-2 bg-transparent f15 sBold text-lightBlack position-relative  ${activeClassName} ${tabClassName}`}
            onClick={() => handleClick(tab)}
            key={index}
            style={{ "--bottomPosition": bottom }}
            disabled={
              (index > 0 && disabled) ||
              disabledIndex === index ||
              disabledIndexes.includes(index)
            }
          >
            {t(`${tab}`)}
            {notificationsCount > 0 && (
              <span
                className="d-flex align-items-center justify-content-center align-middle f12 text-white sBold ms-2"
                style={{
                  borderRadius: notificationsCount < 10 ? "50%" : "20px",
                  backgroundColor: "#a3c5ed",
                  width: notificationsCount < 10 ? "20px" : "35px",
                  minWidth: notificationsCount < 10 ? "20px" : "35px",
                  height: notificationsCount < 10 ? "20px" : "auto",
                  minHeight: notificationsCount < 10 ? "20px" : "auto",
                  lineHeight: "normal",
                }}
              >
                {notificationsCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default TabsNavbar;
